import { AgResourceLanguage } from '../types';
import { sharedComponents as EnUsSharedComponents } from '../en-us/sharedComponents';

export const sharedComponents: AgResourceLanguage['sharedComponents'] = {
  ...EnUsSharedComponents,
  outOfStock: 'Slut i lager',
  comingSoon: 'Kommer Snart',
  button: {
    cancel: 'Avbryt',
    delete: 'Radera',
    remove: 'Ta bort'
  },
  supportCard: {
    title: 'Behöver du hjälp med din beställning?',
    description: 'För mer information',
    linkFAQ: 'besök FAQ-sidan',
    email: 'support@athleticgreens.com',
    phone: '1-888-390-4029',
    phoneHref: '+18883904029'
  },
  paymentInfoBackGuarantee: {
    label: '90-dagars Pengarna Tillbaka-garanti',
    description: 'Om du inte älskar din AG1 inom de första 90 dagarna, får du pengarna tillbaka.'
  },
  paymentInfoCancelAnytime: {
    label: 'Pausa, Ändra eller Avbryt Närsomhelst',
    description: 'Anpassa ditt abonnemang när dina behov förändras. Du har kontrollen.'
  },
  promoCode: {
    promoButtonLabel: 'Använd',
    promoCTA: 'Har du en kampanjkod?',
    promoError: 'Rabattkoden är ogiltig',
    promoInputLabel: 'Kampanjkod'
  },
  summaryCheckout: {
    freePrice: 'Gratis',
    discountLabel: 'Din rabatt',
    totalLabel: 'Totalt',
    taxLabel: 'Moms',
    taxNotReady: '---',
    shippingLabel: 'Frakt',
    subtotalLabel: 'Delsumma',
    taxEstimatedLabel: 'Uppskattad Moms',
    shippingExpectedPrice: 'Gratis'
  },
  addressForm: {
    firstName: 'Förnamn*',
    lastName: 'Efternamn*',
    country: 'Land/region*',
    addressLine1: 'Adress',
    addressLine2: 'Lägenhet, Suite, Etc',
    city: 'Stad',
    province: 'Stat',
    zipCode: 'Postnummer',
    phone: 'Telefon',
    company: 'Företag',
    optional: 'valfritt'
  },
  // MODAL CONTENT
  editShippingAddress: {
    headerEdit: 'Redigera leveransadress',
    headerCreate: 'Skapa leveransadress',
    headerSelect: 'Välj Leveransadress',
    reloadMessage: 'Ladda om sidan',
    titleEditAddress: 'Adressinformation',
    usedSavedLabel: 'Använd sparad adress',
    useSavedAddressText: 'Välj leveransadress för din beställning.',
    noSavedAddressText: 'Du har inga sparade adresser just nu',
    useSavedAddressButton: 'Använd sparad adress',
    noSavedAddressButton: 'Inga sparade adresser',
    defaultAddress: 'Standardadress:',
    defaultAddressText: 'Denna adress används för ditt abonnemang.',
    otherAddresses: 'Ytterligare adresser',
    cancelEditButton: 'Avbryt',
    updateEditButton: 'Uppdatera',
    saveButton: 'Spara',
    cancelSelectButton: 'Avbryt',
    updateSelectButton: 'Använd vald',
    submitSelectButton: 'Ok',
    massUpdate: 'Använd för alla aktiva abonnemang',
    subscriptionUpdate: 'Ange som leveransadress för mitt abonnemang',
    giftTitle: 'Skicka som gåva',
    giftRecipientEmailLabel: 'Mottagarens E-post*',
    giftMessageLabel: 'Gåvobudskap',
    giftAddressClosingAlert: {
      title: 'Stäng Mottagarens Leveransadress',
      content:
        'Är du säker på att du vill stänga leveransadressen utan uppdatering? Din gåva skickas till din standardadress',
      editAddressButton: 'Redigera adress',
      confirmButton: 'Bekräfta'
    }
  },
  acceptDeleteAddress: {
    titleHeader: 'Radera adress',
    description: 'Är du säker på att du vill radera sparad adress?',
    cancelButton: 'Avbryt',
    deleteButton: 'Radera'
  },
  addressVerified: {
    title: 'Bekräfta Din Adress',
    text: 'Vi kunde inte verifiera den angivna adressen. Vänligen kontrollera att den är korrekt eller gör nödvändiga ändringar.',
    suggested: 'Föreslagen Adress',
    entered: 'Angiven Adress',
    edit: 'Redigera Adress',
    continue: 'Spara & Fortsätt'
  },
  giftLabel: {
    short: 'Gåva',
    long: 'Din Gåva'
  },
  v53: {
    originalFlavorTitle: 'Original',
    upgradedFormulaText: 'UPPGRADERAD FORMEL',
    selectFlavorText: 'Välj Smak',
    discardChanges: {
      title: 'Unsaved Changes',
      text: 'Do want to save the changes you made to your subscription?',
      save: 'Save Changes',
      discard: 'Discard Changes'
    }
  }
};
